import * as Card from "@/components/ui/card";
import { Text } from "@/components/ui/text";
import { For, Show, createEffect } from "solid-js";
import { useService } from "solid-services";
import { Divider } from "styled-system/jsx";
import { CommentItem } from "./Item";
import { Post } from "./Post";
import { useComments } from "./state";
import type { CommentsAdapter } from "./types";

interface CommentsProps {
  entityId?: string;
  adapter: CommentsAdapter;
}

export default function Comments(props: CommentsProps) {
  const { comments, commentsQuery, setContext } = useService(useComments)();

  // Sync the external props into our generic singleton service
  createEffect(() => {
    if (props.entityId && props.adapter) {
      setContext(props.entityId, props.adapter);
    }
  });

  return (
    <Show when={props.entityId} fallback={<Text>No Entity Id provided</Text>}>
      <Card.Root p={3} display='grid' gap={3}>
        <Post />
        <Divider />

        <Show when={!commentsQuery.isLoading} fallback={<Text>Loading comments...</Text>}>
          <For each={comments()}>
            {(comment, index) => <CommentItem comment={comment} isLast={index() === comment.replies.length - 1} />}
          </For>
        </Show>

        <Show when={comments().length === 0 && !commentsQuery.isPending}>
          <Text color="fg.muted" textAlign="center" py="4">No comments yet.</Text>
        </Show>
      </Card.Root>
    </Show>
  );
}
